import { render, staticRenderFns } from "./tab_page.vue?vue&type=template&id=545f330e&scoped=true&"
import script from "./tab_page.vue?vue&type=script&lang=js&"
export * from "./tab_page.vue?vue&type=script&lang=js&"
import style0 from "./tab_page.vue?vue&type=style&index=0&id=545f330e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f330e",
  null
  
)

export default component.exports